import axios from '@/api/config'

//首页开始
export const headFootData = data =>
  axios.post('/webAPI/subject/headAndFoot', data) //头部尾部信息
export const navData = data => axios.post('/webAPI/subject/navigation', data) //头部导航
export const homeData = data => axios.post('/webAPI/subject/body', data) //首页主体接口入口
export const bodyData = data => axios.post('/webAPI/subject/bodyData', data) //首页主体数据
// export const linksData = data => axios.post('/webAPI/subject/links', data) //友情链接
export const navigationForZx = data => axios.post('/webAPI/xxwIndex/links', data) //友情链接
// export const navigationForZx = data =>
//   axios.post('/webAPI/meeting/getMeetingLink', data) //友情链接2
export const listData = data => axios.post('/webAPI/subject/list', data) //列表
export const detailData = data => axios.post('/webAPI/subject/view', data) //详情
